import { memo, ReactNode } from 'react'

export type BodySharedBlockProps = {
  children: ReactNode
}

export const BodySharedBlock = memo<BodySharedBlockProps>(({ children }) => {
  return <>{children}</>
})

BodySharedBlock.displayName = 'BodySharedBlock'
